export class MapPosition {
  constructor(
    public lat: number,
    public lng: number,
    public zoom: number,
  ) {
  }
}
